<template>
  <div class="main">
    <div class="main_header">
      <div class="header_item">
        <span class="header_label">分公司名称：</span>
        <el-input v-model="companyName" clearable placeholder="请输入分公司名称"></el-input>
      </div>
      <div class="header_item">
        <el-button v-if="showButton('search')" icon="el-icon-search" @click="searchFilialeList(true)">查询</el-button>
        <el-button class="search_btn" v-if="showButton('insert')" icon="el-icon-plus" @click="propInsert()">新增</el-button>
      </div>
    </div>
    <div class="main_content">
      <el-table
        v-loading="loading"
        :data="filaleList"
        height="100%">
        <el-table-column label="序号" width="55" align="center">
          <template #default="scope">
            <span>{{(pageNum - 1) * pageSize + scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="companyName" label="分公司名称" align="center"></el-table-column>
        <el-table-column prop="companyAdmin" label="负责人" align="center"></el-table-column>
        <el-table-column prop="companyPhone" label="联系电话" align="center"></el-table-column>
        <el-table-column prop="address" label="地址" align="center"></el-table-column>
        <el-table-column prop="remark" label="备注" show-overflow-tooltip align="center"></el-table-column>
        <el-table-column label="操作" align="center">
          <template #default="{ row }">
            <el-button class="table_btn" size="mini" v-if="showButton('update')" @click="propUpdate(row)">修改</el-button>
            <el-button class="delete_btn" size="mini" v-if="showButton('delete')" @click="deleteInfo(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="main_footer">
      <el-pagination
        background
        @current-change="changePageNum"
        @size-change="changePageSize"
        :current-page="pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 新增分公司 修改分公司信息 -->
    <el-dialog
      class="prop_dialog"
      :title="asyncTitle ? '新增分公司' : '修改分公司信息'"
      :visible.sync="asyncFiaiale"
      width="35%">
      <el-form ref="form" :model="formFiaiale" :rules="rulesFiaiale" label-width="auto" class="rule_form">
        <el-form-item label="分公司名称：" prop="companyName">
          <el-input v-model="formFiaiale.companyName" clearable placeholder="请输入分公司名称"></el-input>
        </el-form-item>
        <el-form-item label="负责人：" prop="companyAdmin">
          <el-input v-model="formFiaiale.companyAdmin" clearable placeholder="请输入负责人"></el-input>
        </el-form-item>
        <el-form-item label="联系人电话：" prop="companyPhone">
          <el-input v-model="formFiaiale.companyPhone" clearable placeholder="请输入联系人电话"></el-input>
        </el-form-item>
        <el-form-item label="地址：" prop="address">
          <el-input v-model="formFiaiale.address" clearable placeholder="请输入地址"></el-input>
        </el-form-item>
        <el-form-item label="是否完成：" prop="isFinish">
          <el-radio-group v-model="formFiaiale.isFinish">
            <el-radio :label="1">已完成</el-radio>
            <el-radio :label="2">未完成</el-radio>
            <el-radio :label="3">待建</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="链接地址：" prop="targetUrl">
          <el-input v-model="formFiaiale.targetUrl" clearable placeholder="请输入链接地址"></el-input>
        </el-form-item>
        <el-form-item label="备注：">
          <el-input 
            v-model="formFiaiale.remark"
            type="textarea"
            clearable 
            placeholder="请输入备注"
            maxlength="200"
            show-word-limit
            ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="asyncFiaiale = false">取 消</el-button>
        <el-button @click="asyncTitle ? submitInsertForm() : submitUpdateForm()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { buttonPinia } from '../../pinia';
import { throttle } from '../../plugins/public';
  export default {
    data() {
      return {
        companyName: '',
        pageNum: 1,
        pageSize: 10,
        total: 0,
        loading: true,
        filaleList: [],
        asyncTitle: true, // true 新增 false 修改
        asyncFiaiale: false, // 弹窗
        formFiaiale: {}, // 表单信息
        rulesFiaiale: {
          companyName: [{
            required: true,
            message: '请输入分公司姓名',
            trigger: 'blur'
          }],
          companyAdmin: [{
            required: true,
            message: '请输入负责人',
            trigger: 'blur'
          }],
          companyPhone: [{
            required: true,
            message: '请输入联系电话',
            trigger: 'blur'
          },{
            pattern:
              /^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/,
            message: '请输入正确的手机号码',
            trigger: 'blur'
          }],
          address: [{
            required: true,
            message: '请输入地址',
            trigger: 'blur'
          }],
          isFinish: [{
            required: true,
            message: '请选择是否完成',
            trigger: ['blur', 'change']
          }],
          targetUrl: [{
            required: true,
            message: '请输入链接地址',
            trigger: 'blur'
          }]
        }, // 表单校验信息
      }
    },
    mounted() {
      this.searchFilialeList(true);
    },
    methods: {
      searchFilialeList(bol) {
        if(bol) {
          this.pageNum = 1;
        }
        this.loading = true;
        this.filaleList = [];
        this.$api.Basics.SEARCHFILIALELIST({
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          companyName: this.companyName
        }).then((res) => { 
          if(res.success) {
            this.total = res.data.total;
            this.filaleList = res.data.list;
          }
          this.loading = false;
        }).catch(() => {
          this.loading = false;
        })
      },
      // 打开添加信息
      propInsert() {
        this.asyncTitle = true;
        this.asyncFiaiale = true;
      },
      // 打开修改信息
      propUpdate(row) {
        this.asyncTitle = false;
        this.asyncFiaiale = true;
        this.$set(this.formFiaiale, 'companyId', row.companyId);
        this.$set(this.formFiaiale, 'companyName', row.companyName);
        this.$set(this.formFiaiale, 'companyAdmin', row.companyAdmin);
        this.$set(this.formFiaiale, 'companyPhone', row.companyPhone);
        this.$set(this.formFiaiale, 'address', row.address);
        this.$set(this.formFiaiale, 'isFinish', row.isFinish);
        this.$set(this.formFiaiale, 'targetUrl', row.targetUrl);
        this.$set(this.formFiaiale, 'remark', row.remark);
      },
      // 删除分公司信息
      deleteInfo(row) {
        this.$confirm("该操作将删除该分公司信息，是否继续删除?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
       })
       .then(() => {
         this.$api.Basics.DELETEFILIALEINFO({companyId: row.companyId})
        .then(res => {
          if(res.success) {
            this.searchFilialeList(true);
            this.$message.success("删除成功！");
          } else {
            this.$message.warning(res.statusMsg);
          }
        })
       })
       .catch(() => {
         this.$message.warning("您已取消");
       })
      },
      // 提交添加信息
      submitInsertForm: throttle(function() {
        this.$refs.form.validate((valid) => {
          if(valid) {
            const params = Object.assign({}, this.formFiaiale);
            this.$api.Basics.INSERTFILIALEINFO(params).then((res) => {
              if(res.success) {
                this.asyncFiaiale = false;
                this.searchFilialeList(true);
                this.$message.success('添加成功！');
                this.$notify({
                  title: '提示',
                  message: `账号为：${res.data}, 密码为：123456`,
                  duration: 0
              });
              } else {
                this.$message.warning(res.statusMsg);
              }
            })
          }
        })
      }, 3000),
      // 提交修改信息
      submitUpdateForm: throttle(function() {
        this.$refs.form.validate((valid) => {
          if(valid) {
            const params = Object.assign({}, this.formFiaiale);
            this.$api.Basics.INSERTFILIALEINFO(params).then((res) => {
              if(res.success) {
                this.asyncFiaiale = false;
                this.searchFilialeList(true);
                this.$message.success('修改成功！');
              } else {
                this.$message.warning(res.statusMsg);
              }
            })
          }
        })
      }, 3000),
      // 切换页码
      changePageNum(page) {
        this.pageNum = page;
        this.searchFilialeList();
      },
      // 切换每页条数
      changePageSize(size) {
        this.pageSize = size;
        this.searchFilialeList();
      },
      // 判断按钮权限信息
      showButton(str) {
        const pinia = buttonPinia();
        return pinia.$state.buttonInfo.includes(str);
      }
    },
    watch: {
      asyncFiaiale(bol) {
        if(!bol) {
          this.formFiaiale = {};
          this.$refs.form.resetFields();
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
@import '../../style/layout-main.scss';

/deep/ .el-radio {
  padding: 8px 0;
}
</style>